import type { LandingTestimonial } from "./LandingTestimonials";

export const averageTestimonialRating = (testimonials: LandingTestimonial[]) => {
  if (testimonials.length === 0) {
    return 0;
  }

  const total = testimonials.reduce((sum, testimonial) => sum + testimonial.rating, 0);
  return total / testimonials.length;
};
